export const couponSettings = {
  mode: 'manual',
  couponCode: 'COUPON',
  couponList: 'COUPON1\nCOUPON2\nCOUPON3',
  prefix: '',
  length: 6,
  characters: 'lettersAndNumbers',
  color: 'rgb(17, 17, 17)',
  font: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 16
  },
  borderRadius: 4,
  fullWidth: true,
  messages: {
    copied: 'COPIED!',
    clickToCopy: 'Click To Copy'
  },
  mobileFont: {
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 16
  },
  visible: true,
  devicesVisible: 'allDevices'
} as const;
